export default "__VITE_ASSET__ced12030__"